import { useState } from "react";
import { Building2 } from "lucide-react";

/**
 * Renders a client logo if provided and the image loads,
 * otherwise falls back to a tasteful text plate with the client name.
 * Never generates a fake logo.
 */
export default function ClientLogo({ client, className = "", monochrome = true }) {
  const [failed, setFailed] = useState(false);
  const showImage = client.logo && client.displayLogo !== false && !failed;

  if (showImage) {
    const scale = client.logoScale && client.logoScale !== 1 ? { transform: `scale(${client.logoScale})` } : undefined;
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <img
          src={client.logo}
          alt={client.name}
          loading="lazy"
          onError={() => setFailed(true)}
          style={scale}
          className={`max-h-full max-w-full object-contain transition duration-300 ${
            monochrome ? "opacity-70 grayscale hover:grayscale-0 hover:opacity-100" : ""
          }`}
        />
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center gap-2 text-neutral-500 ${className}`} aria-label={client.name}>
      <Building2 size={18} strokeWidth={1.5} aria-hidden="true" />
      <span className="font-heading text-sm font-medium tracking-tight text-neutral-700 leading-tight text-center">
        {client.name}
      </span>
    </div>
  );
}
